import { IUser } from "@/v1/types";
import { buildExportFileName } from "@/v1/utils";

/*
 * One name for both downloads of a tax registration (XML and PDF):
 * `<Mandant> - FsE.<ext>` (SMT-1454), like every other export.
 *
 * The Mandant comes from the master data, not from the questionnaire: the
 * questionnaire holds what was typed for the filing, the master data is the
 * name the Tax Ops team searches for. No KapG/EUN suffix and no date: the
 * Rechtsform is on the record and the browser adds a number for a second file.
 *
 * `fallback` is the record id. It only appears when the Mandant is missing or
 * has neither a name nor an email, so the file still gets a name that
 * identifies the record.
 */
export const getTaxRegistrationFileName = ({
  extension,
  user,
  fallback,
}: {
  extension: "xml" | "pdf";
  user?: Pick<
    IUser,
    "firstName" | "lastName" | "businessTradingName" | "companyType" | "email"
  > | null;
  fallback: string;
}) =>
  buildExportFileName({
    user: { ...user, email: user?.email || fallback },
    exportType: "FsE",
    extension,
  });
